import styled from "styled-components";
import { Select } from "../select/Select";
import { usePatchDocumentationAreaLocale } from "src/apps/hooks/usePatchDocumentationAreaLocale";
import { useEffect } from "react";
import { useDocumentationArea } from "src/apps/hooks/useDocumentationArea";

import { useLocale } from "src/apps/hooks/useLocale";
import {
  AnalyticsEvents,
  useSendAnalyticEvent,
} from "src/apps/hooks/analytics/useSendAnalyticEvent";
import { colors } from "@permisso/permisso-components";

export const LocaleSelector = () => {
  const { documentationArea } = useDocumentationArea();
  const { mutate: patchLocale } = usePatchDocumentationAreaLocale();
  const { locale, setLocale, availableLocales } = useLocale();
  const { sendEvent } = useSendAnalyticEvent();

  const documentationAreaLocale = documentationArea?.getLocale();

  const onSelectedLocale = (newLocale: string) => {
    setLocale(newLocale);
    patchLocale(newLocale);
    sendEvent(AnalyticsEvents.DOCUMENTATION_AREA_LOCALE_CHANGED, {
      old_locale: locale ?? "",
      new_locale: newLocale ?? "",
    });
  };

  useEffect(() => {
    if (documentationAreaLocale) {
      setLocale(documentationAreaLocale);
    }
  }, [documentationAreaLocale]);

  const orderedLocales = availableLocales
    ?.map((locale) => locale.toUpperCase())
    ?.sort((a) => {
      return a !== locale ? 1 : -1;
    });

  if (!orderedLocales || orderedLocales.length < 2 || !locale) return null;
  return (
    <Container>
      <Select
        options={orderedLocales.map((locale) => ({
          key: locale,
          value: locale.toLocaleLowerCase(),
        }))}
        value={locale}
        setSelectedValue={(localeValue) => onSelectedLocale(localeValue)}
        variant="unstyled"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 0 0.5rem 0.5rem;
  border-radius: 0.375rem;
  min-width: 3.75rem;
  &:hover {
    cursor: pointer;
    background-color: ${colors.grey300};
  }
`;
